module.exports = __webpack_public_path__ + "media/Images/BottomBg-03b703050a0fc90f7c4570393a7d7ec3.svg";